import type { OptionItem } from './OptionGroup';
import type { ReactElement } from 'react';

import { FilterCheckbox } from './FilterCheckbox';
import { DetailsListItem, DetailBtn } from './OptionGroupStyles';

type StandardFilterItemProps = {
  item: OptionItem;
  onSelect: (key: string) => void;
  checkboxType?: string;
  getIconColor?: (bg?: string) => string | undefined;
  tabIndex?: number;
};

export const StandardFilterItem = ({
  item,
  onSelect,
  checkboxType,
  getIconColor,
  tabIndex,
}: StandardFilterItemProps): ReactElement => (
  <DetailsListItem key={item.key} role={checkboxType === 'round' ? 'none' : undefined}>
    <DetailBtn
      type="button"
      role={checkboxType === 'round' ? 'radio' : 'checkbox'}
      aria-checked={item.selected}
      onClick={() => onSelect(item.key)}
      tabIndex={tabIndex}
      data-testid={item.testId}
    >
      <FilterCheckbox item={item} checkboxType={checkboxType} getIconColor={getIconColor} />
      {item.label.replace(/[()]/g, '')}
    </DetailBtn>
  </DetailsListItem>
);
